import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setCurrentStep, setHeldUnderAge, setSelectedActivity, setVisitors } from "../../store/MahutiReducer";
import { ELEMENT_LINK, FLOW_TYPE, GET_CAMP_ERR_MSG, scrollToSection } from "../../utils/GlobalParams";
import { getCampainsSF } from "../../utils/sfUtils";
import { isGenericOnlyLp, visitorsPatchForProduct } from "../../utils/audienceUtils";
import { mySteps, onBrowserBackButtonHandle } from "../../utils/stepperUtils";
import MahutiActivitiesList from "../mahuti-activities/MahutiActivitiesList";
import './LandingPageStepTwo.css'


function LandingPageStepTwo(props) {

    const store = useSelector(store => store.reducer);
    const [resActivities, setResActivities] = useState([]);
    const [isLoadingActivities, setIsLoadingActivities] = useState(true);
    const [errorMessageHead, setErrorMessageHead] = useState(undefined)

    const refMount = useRef(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const getCampains = () => {
        getCampainsSF(store.activityDate, store.visitors, store.lpName || undefined)
            .then(res => {
                setResActivities(res.data.records);
                setErrorMessageHead(undefined);
                setIsLoadingActivities(false)
            })
            .catch((err) => {
                setErrorMessageHead(GET_CAMP_ERR_MSG); 
                setIsLoadingActivities(false)
            });
    }


    useEffect(() => {
        if (refMount.current) {
            scrollToSection(ELEMENT_LINK["#sellingflow"])
            refMount.current = false;
            // onrefresh

            if(store.activityDate && store.visitors){
                getCampains()
            }else{
                
            }
            
        }
        return () => {

            onBrowserBackButtonHandle(store, dispatch, navigate, location, () => dispatch(setSelectedActivity(undefined)));
         }
    }, [])

    // Date-first flow picks visitors BEFORE the activity: selecting a generic
    // event here zeroes the child tickets, holding the chosen count so the
    // next family selection restores it (the up-front visitors choice carries
    // across products in one session) - same rule as the activity flow.
    useEffect(() => {
        const patch = visitorsPatchForProduct(store.selectedActivity, store.visitors, store.isInternalMode, store.heldUnderAge, isGenericOnlyLp(store.products));
        if (patch) {
            dispatch(setHeldUnderAge(patch.underAge === 0 ? store.visitors?.underAge : undefined));
            dispatch(setVisitors(patch));
        }
    }, [store.selectedActivity])
    return <div id="main-content" className="LandingPageStepTwo">
        {errorMessageHead && <div className="alert alert-text">{errorMessageHead}</div>}
        {isLoadingActivities ? <div className="col"><div className="loader" /></div>  : <MahutiActivitiesList tickets={resActivities} />}

    </div>
}


export default LandingPageStepTwo;